import React from "react";
import VerticalTabs from "../../common/VerticalTabs";

const Test = () => {
  return <p>Test</p>;
};

const tabs = [
  { id: "projects", label: "Manage Projects", component: Test },
  {
    id: "managers",
    label: "Manage Managers",
    component: Test,
  },
  {
    id: "assignment",
    label: "Manage Assignment",
    component: Test,
  },
];

const Index: React.FC = () => {
  return <VerticalTabs tabs={tabs} title="Zoho Projects" />;
};

export default Index;
